import { StateCreator } from 'zustand/vanilla';
import { AttributeCode } from 'services/model/model.service';

export type FilterAttributeCode = AttributeCode | 'dateRange' | 'comparisonDateRange' | 'creationDateRange';

export interface DisabledFilters {
  disabledFilters: FilterAttributeCode[];
}
export interface DisabledFiltersActions {
  setDisabledFilters(attributes: FilterAttributeCode[]): void;
  disableFilter(attribute: FilterAttributeCode): void;
  enableFilter(attribute: FilterAttributeCode): void;
  enableAllFilters(): void;
}

export interface HiddenFilters {
  hiddenFilters: FilterAttributeCode[];
}

export interface HiddenFiltersActions {
  hideFilter(attribute: FilterAttributeCode): void;
  showFilter(attribute: FilterAttributeCode): void;
  showAllFilters(): void;
}

export interface DisabledFiltersSlice extends DisabledFilters, DisabledFiltersActions {}

export const createDisabledFiltersSlice: StateCreator<DisabledFiltersSlice, [], [], DisabledFiltersSlice> = set => ({
  disabledFilters: [],
  setDisabledFilters: attributes => set(() => ({ disabledFilters: [...attributes] })),
  enableAllFilters: () => set(() => ({ disabledFilters: [] })),
  disableFilter: attribute =>
    set(state =>
      state.disabledFilters.includes(attribute)
        ? { disabledFilters: state.disabledFilters }
        : { disabledFilters: [...state.disabledFilters, attribute] }
    ),
  enableFilter: attribute =>
    set(state => ({ disabledFilters: state.disabledFilters.filter(att => att !== attribute) })),
});

export interface HiddenFiltersSlice extends HiddenFilters, HiddenFiltersActions {}

export const createHiddenFiltersSlice: StateCreator<HiddenFiltersSlice, [], [], HiddenFiltersSlice> = set => ({
  hiddenFilters: [],
  showAllFilters: () => set(() => ({ hiddenFilters: [] })),
  hideFilter: attribute =>
    set(state =>
      state.hiddenFilters.includes(attribute)
        ? { hiddenFilters: state.hiddenFilters }
        : { hiddenFilters: [...state.hiddenFilters, attribute] }
    ),
  showFilter: attribute => set(state => ({ hiddenFilters: state.hiddenFilters.filter(att => att !== attribute) })),
});
